import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import flechaAvanzar from "../assets/right-arrow.svg";
import silentAvatar from "../assets/avatares/revisad-datos-clave.mp4";
import { ROUTES } from "../utils/constants";
import "./StartGame.css";

export default function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const [loading, setLoading] = useState(false);

	const handleNext = () => {
		if (loading) return;
		setLoading(true);
		getGameById(game?._id)
			.then((res) => {
				if (res.status === 200) {
					navigate(ROUTES.SCENARIO1_INTRO, {
						state: { activeScenario: 1 },
					});
				}
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<div className="start-game-page start-game-page--welcome">
			<div className="start-game-inner start-game-inner--prep5">
				<span className="start-game-badge sg5-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Planeta
				</span>

				<div className="sg5-scroll">
					<header className="sg5-hero">
						<h1 className="sg5-title">
							Contexto{" "}
							<span className="sg5-title-accent">estratégico</span>
						</h1>
					</header>

					<div className="sg5-mosaic">
						<div className="sg5-mosaic-media">
							<div className="sg5-video-shell">
								<div className="start-game-avatar-inner start-game-avatar-inner--silent sg5-video-inner">
									<video
										autoPlay
										playsInline
										preload="auto"
										aria-hidden
									>
										<source src={silentAvatar} type="video/mp4" />
									</video>
								</div>
							</div>
						</div>

						<div className="sg5-mosaic-aside">
							<div className="sg5-aside-card">
								<p>
									Revisad los datos clave sobre la situación actual de Cobega: su trayectoria, su estructura empresarial, los cambios del entorno y los retos que afronta en este momento de transformación.
								</p>
							</div>
							<div className="sg5-aside-card">
								<p>
									Antes de tomar decisiones, será importante entender bien de dónde viene la compañía, en qué punto se encuentra ahora y qué elementos pueden condicionar su futuro.
								</p>
							</div>
							<div className="sg5-aside-card">
								<p>
									Prestad atención: la información que aparezca será clave para interpretar los próximos retos y tomar mejores decisiones durante la dinámica.
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="sg5-actions">
					<button
						type="button"
						className="start-game-cta sg5-cta"
						onClick={(e) => {
							e.preventDefault();
							if (!loading) handleNext();
						}}
						disabled={loading}
						aria-busy={loading}
					>
						{loading ? (
							<span className="start-game-cta-spinner" aria-hidden />
						) : (
							<img className="start-game-cta-icon" src={flechaAvanzar} alt="" />
						)}
						{loading ? "Cargando…" : "Continuar con la dinámica"}
					</button>
				</div>
			</div>
		</div>
	);
}
